import { deleteDoc, doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/services/firebase';

const COLLECTION = 'messengerAppPresence';

/** Если heartbeat старше — пользователь не в приложении (вкладка закрыта / фон). */
export const MESSENGER_PRESENCE_STALE_MS = 45_000;

/** Интервал записи «я в мессенджере» (должен быть < STALE_MS). */
export const MESSENGER_HEARTBEAT_MS = 18_000;

/**
 * Подписка: пользователь `peerUid` недавно слал heartbeat из любой страницы `/app/*`.
 */
export type PeerMessengerPresenceSnapshot = {
  isActiveInApp: boolean;
  /** 0 — нет документа; иначе millis последнего heartbeat (в т.ч. после сворачивания вкладки). */
  lastSeenAtMs: number;
};

export function subscribePeerMessengerPresence(
  peerUid: string,
  onUpdate: (s: PeerMessengerPresenceSnapshot) => void
): () => void {
  const r = doc(db, COLLECTION, peerUid);
  let lastMs = 0;
  let docExists = false;

  const apply = () => {
    const fresh =
      docExists && lastMs > 0 && Date.now() - lastMs < MESSENGER_PRESENCE_STALE_MS;
    const lastSeenAtMs = docExists && lastMs > 0 ? lastMs : 0;
    onUpdate({ isActiveInApp: fresh, lastSeenAtMs });
  };

  const unsubSnap = onSnapshot(
    r,
    (snap) => {
      docExists = snap.exists();
      const u = snap.data()?.updatedAt as { toMillis?: () => number } | undefined;
      lastMs = typeof u?.toMillis === 'function' ? u.toMillis() : 0;
      apply();
    },
    () => {
      docExists = false;
      lastMs = 0;
      apply();
    }
  );

  const tick = window.setInterval(apply, 4000);

  return () => {
    window.clearInterval(tick);
    unsubSnap();
  };
}

export async function heartbeatMessengerAppPresence(uid: string): Promise<void> {
  // Важно: без merge, чтобы вычистить возможные legacy-поля и пройти strict rules (только updatedAt).
  await setDoc(doc(db, COLLECTION, uid), { updatedAt: serverTimestamp() });
}

export async function clearMessengerAppPresence(uid: string): Promise<void> {
  try {
    await deleteDoc(doc(db, COLLECTION, uid));
  } catch {
    /* сеть / правила */
  }
}
